import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import { CanalDistribuicaoViewProps, mapDispatchToCanalDistribuicaoProps, mapStateToCanalDistribuicaoProps } from "../../canalDist/canalDist.controll";
import { Select } from "../../../components/select";
import { FiltroReadMovCanal, TotalFaturadoProps } from "../../canalDist/canalDist.model";
import { formatData, formatMoney } from "../../../services/utils";
import { GridColDef } from "@mui/x-data-grid";
import { connect } from "react-redux";
import { CanalDistShellModal } from "../../canalDist/view/canalDist.shell"
import { useState } from "react";


const columns: GridColDef[] = [
    { field: 'data', headerName: 'Data', flex: 5 },
    { field: 'total', headerName: 'Total', flex: 3, valueGetter:(value)=>formatMoney(value) },
]

function ListFaturamentoDetalhado(props: CanalDistribuicaoViewProps) {
    const { canalDistribuicaoActions, canalDistribuicaoState } = props;
    const { rowsTotalFatPeriodo,changeList,loading,status,msg, } = canalDistribuicaoState
    const { setShowAlert } = canalDistribuicaoActions
    const somaTotal = rowsTotalFatPeriodo.reduce((acc, curr) => acc + curr.total, 0);
    const [showModalShell,setShowModalShell] = useState(false)

    console.log("canalDistribuicaoState", canalDistribuicaoState);
    const onClick = (row: TotalFaturadoProps) => {
        let dt = new Date(`${row.id[0]}-${row.id[1]}-${row.id[2]}` );
        console.log("Data formatada:", dt.toISOString());
        let filtro:FiltroReadMovCanal = {
            canal_id: "",
            dtIni: dt.toISOString(),
            dtFim: dt.toISOString(),
            periodo:"diario"
        }
        console.log("Filtro ReadMovCanal",filtro)
        canalDistribuicaoActions.readCanalDistByData(filtro)
        canalDistribuicaoActions.setShowCadModal(true);
    }

    return (
        <Card variant="outlined" sx={{ width: '100%' }}>
            <CardHeader
                title={`Total Faturado no Período - ${formatMoney(somaTotal)}`}
            />
            <CardContent>
                <Select
                    ListItemTextPrimary={(row: TotalFaturadoProps) => (
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography>{formatData(row.data)}</Typography>
                            <Typography>{formatMoney(row.total)}</Typography>
                        </Box>
                    )}
                    columns={columns}
                    rows={rowsTotalFatPeriodo}
                    row={{}}
                    msg=""
                    buttonNew={{
                        show: false,
                        onClick: () => { }
                    }}
                    buttonRefresh={{
                        show: false,
                        onClick: () => {}
                    }}
                    changeList={changeList}
                    closeAlert={()=>setShowAlert(false)}
                    displayWidth={window.innerWidth}
                    fieldSearch={"data"}
                    orderBy="id"
                    getRowId={(row:TotalFaturadoProps)=>row.id}
                    handleOnChange={onClick}
                    loading={loading}
                    setTextSearch={()=>{}}
                    showAlert={false}
                    textSearch={""}
                    title={`Faturamento Detalhado`}
                    variantToobar="dense"
                    elevation={1}
                    fontSize={16}
                    status={status}
                    showSearchContainer={false}
                    setRow={(row)=>{}}
                />
                <CanalDistShellModal 
                    {...props}
                />
            </CardContent>
        </Card>
    )
}

export default connect(mapStateToCanalDistribuicaoProps, mapDispatchToCanalDistribuicaoProps)(ListFaturamentoDetalhado);